import React, { Component } from "react";
import Lookup from "devextreme-react/lookup";
import {
  ExecuteLayoutEventMethods,
  GetControlPropertyFromStoreOrRefData,
  getProcessedDynamic,
} from "../../../General/commonFunctions";
import { ownStore } from "../../../AppOwnState/ownState";

class FactsDevLookup extends Component {
  constructor(props) {
    super(props);
    this.rowIndex =
      GetControlPropertyFromStoreOrRefData(props.rowindex, props.refData) ?? "";

    this.listdset = getProcessedDynamic(props.listdset);
    let _listData = ownStore.getState(this.props.listdset);

    let selectValueFromState = props.initialvalue;
    if (this.props.dset && this.props.valueExpr) {
      selectValueFromState = GetControlPropertyFromStoreOrRefData(
        "[" +
          props.dset +
          "." +
          (this.rowIndex === "" ? "" : this.rowIndex + ".") +
          props.valueExpr +
          "]",
        props.refData
      );
    }
    this.state = {
      selectValue: this.emptyIfValueNotValid(selectValueFromState),
      listData: _listData,
    };
  }

  emptyIfValueNotValid(value) {
    if (this.props?.SelectProps?.multiple && !Array.isArray(value)) return [];
    else return value;
  }

  componentDidMount() {
    this.mounted = true;

    this.unsubscribe = ownStore.subscribe((storeInfo) => {
      if (this.mounted) {
        if (
          [storeInfo.dset, "raw"].includes(this.props.dset) &&
          (storeInfo.field ?? this.props.valueExpr) === this.props.valueExpr
        ) {
          if (this.props.dset && this.props.valueExpr) {
            let newState = GetControlPropertyFromStoreOrRefData(
              "[" +
                this.props.dset +
                "." +
                (this.rowIndex === "" ? "" : this.rowIndex + ".") +
                this.props.valueExpr +
                "]",
              this.props.refData
            );

            if (this.state.selectValue !== newState) {
              this.setState({
                selectValue: this.emptyIfValueNotValid(newState),
              });
            }
          }
        }

        if (storeInfo.dset === "this" || storeInfo.dset === this.listdset) {
          let newList = ownStore.getState(this.listdset);
          let thisListString = JSON.stringify(this.state.listData);
          let newListString = JSON.stringify(newList);
          if (thisListString !== newListString) {
            this.setState({
              listData: newList,
            });
          }
        }
      }
    });
  }

  componentWillUnmount() {
    if (this.unsubscribe) this.unsubscribe();
    this.mounted = false;
  }

  async saveCurrentTextToDataset() {
    if (this.props.dset && this.props.valueExpr) {
      if (this.rowIndex !== "") {
        let rowData = GetControlPropertyFromStoreOrRefData(
          "[" + this.props.dset + "." + this.rowIndex + "]",
          this.props.refData
        );

        await ExecuteLayoutEventMethods([
          {
            exec: "mergedatasetarray",
            args: {
              noprocess: true,
              dset: this.props.dset,
              index: parseInt(this.rowIndex),
              data: {
                ...rowData,
                [this.props.valueExpr]: this.state.selectValue,
              },
            },
          },
        ]);
      } else {
        await ExecuteLayoutEventMethods([
          {
            exec: "setdatasetfield",
            args: {
              noprocess: true,
              dset: this.props.dset,
              fieldname: this.props.valueExpr,
              data: this.state.selectValue,
            },
          },
        ]);
      }
    }
  }

  async runCustomOnChangeEvents() {
    await this.saveCurrentTextToDataset();
    await ExecuteLayoutEventMethods(this.props.whenchange, this.state);
  }

  handleOnValueChange(e) {
    this.setState(
      {
        selectValue: e.value,
      },
      () => {
        this.runCustomOnChangeEvents();
      }
    );
  }

  async handleOnClick(e) {
    await ExecuteLayoutEventMethods(this.props.whenitemclick, e);
  }

  async handleOnOpen(e) {
    await ExecuteLayoutEventMethods(this.props.whenopened, e);
  }

  render() {
    return (
      <div>
        <Lookup
          value={this.state.selectValue}
          dataSource={this.state.listData}
          {...this.props}
          onValueChanged={(e) => this.handleOnValueChange(e)}
          onItemClick={(e) => this.handleOnClick(e)}
          onOpened={(e) => this.handleOnOpen(e)}
        ></Lookup>
      </div>
    );
  }
}

export default FactsDevLookup;
